import { AppState } from '../../types/store';

export const getHasApps = (state: AppState) => state.studio?.apps?.hasApps ?? false;

export const getAppData = (state: AppState) => state.studio?.apps?.appData ?? {};

export const getAppDataById = (state: AppState, deviationId: number) =>
  state.studio?.apps?.appData?.[deviationId];
